import { styled, Theme } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import { AppTheme } from "types/general.types"

type Size = "small" | "medium";

type ProgressBarProps = {
  slidesCount: number;
  currentSlideIndex: number;
  size?: Size;
  mode: AppTheme;
}

export default function SwiperIndicator(props: ProgressBarProps) {
  const { slidesCount, currentSlideIndex, mode, size = "medium" } = props

  return (
    <Container gap={size === "medium" ? "8px" : "4px"}>
      {new Array(slidesCount).fill(null).map((slide, index) => (
        <Indicator
          key={index}
          mode={mode}
          active={index === currentSlideIndex ? 1 : 0}
          size={size}
        />
      ))}
    </Container>
  )
}

type IndicatorProps = {
  theme?: Theme;
  active: 0 | 1;
  mode: AppTheme;
  size: Size;
}

const Container = styled(Stack)(() => ({
  flexDirection: "row-reverse",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  bottom: "24px",
  right: "50%",
  transform: "translateX(50%)",
  zIndex: 4
}))

const Indicator = styled("div")(({ theme, active, mode, size }: IndicatorProps) => ({
  width: active ? (size === "medium" ? "32px" : "20px") : (size === "medium" ? "12px" : "8px"),
  height: (size === "medium" ? "12px" : "8px"),
  backgroundColor: active ?
    (mode === "light" ? theme?.palette.primary["6"] : theme?.palette.primary["1"]) :
    (mode === "light" ? theme?.palette.primary["4"] : theme?.palette.primary["5"]),
  borderRadius: active ? "32px" : "50%"
}))
